// The first-time-use modal must paint above the video wall overlay
// (VIDEO_WALL_Z_INDEX = 2000), app chrome, and the emergency-call container
// (z-index 1401), so the tour is visible even while a feature overlay is open.
export const FTU_MODAL_Z_INDEX = 2100

// Analytics event names.
export const FTU_ANALYTICS = {
  started: 'FTU Started',
  stepViewed: 'FTU Step Viewed',
  completed: 'FTU Completed',
} as const
